import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { CdekLocation } from './CdekLocation'
import { OrderCdekDeliveryTimes } from './OrderCdekDeliveryTimes'
/**
* Class OrderDeliveryMethodCdekDto
*  Специфика доставки CDEK.
*/
export class OrderDeliveryMethodCdekDto extends ActiveModel {

  /**
  * kind
  *   */
  @ActiveField({ readonly: true, value: () => 'Cdek' })
  readonly kind: string = 'Cdek'


  /**
  * to
  * Адрес / ПВЗ назначения.  */
  @ActiveField({
    factory: [CdekLocation, () => undefined]
  })
  to?: CdekLocation


  /**
  * times
  * Сроки доставки (калькулятор + Extra*).  */
  @ActiveField({
    factory: [OrderCdekDeliveryTimes, () => undefined]
  })
  times?: OrderCdekDeliveryTimes


  /**
  * cdekOrderNumber
  * Номер заказа в CDEK.  */
  @ActiveField()
  cdekOrderNumber?: null | number
}
